import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { DeleteOcrAccountsRequestModel, DeleteOcrAccountsResponseModel } from "@/features/accounts/ocr/services/delete-accounts-model";

export class DeleteOcrAccountsApi {
  /**
   * OCR口座削除API
   */
  public deleteOcrAccounts = async (
    param: DeleteOcrAccountsRequestModel
  ): Promise<DeleteOcrAccountsResponseModel> => {
    const path = `/api/ocraccounts`;
    const res = await ApiClient.instance.delete<DeleteOcrAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
